import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1c7e5346"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "agent-type-cell"
};
const _hoisted_2 = {
  class: "agent-title"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title-bottom-line"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "line"
}), /*#__PURE__*/_createElementVNode("span", {
  class: "line"
})], -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "agent-bottom"
}, null, -1));
const _hoisted_6 = {
  key: 0,
  class: "agent-button"
};
import ButtomCom from '@/components/buttomCom.vue';
export default {
  __name: 'agentCom',
  props: {
    showBotton: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    pageUrl: {
      type: String,
      default: '/bookDemoPage.html'
    },
    flexRevert: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const jumpPage = url => {
      // 获取当前页面地址
      url = `${url}?trackCode=${window.location.href.split('//')[1]}`;
      window.open(url);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("p", _hoisted_3, _toDisplayString(__props.title), 1), _hoisted_4]), _createElementVNode("div", {
        class: _normalizeClass(__props.flexRevert ? 'agent-content agent-revert' : 'agent-content')
      }, [_renderSlot(_ctx.$slots, "left"), _renderSlot(_ctx.$slots, "right")], 2), _renderSlot(_ctx.$slots, "bottom", {}, () => [_hoisted_5]), __props.showBotton ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(ButtomCom, {
        isMore: true,
        isArrow: false,
        effect: 'light',
        "btn-name": '了解更多',
        style: {
          "margin-right": "16px"
        },
        onClick: _cache[0] || (_cache[0] = $event => jumpPage(__props.pageUrl)),
        class: ""
      }), _createVNode(ButtomCom, {
        effect: 'plain',
        isMore: false,
        "btn-name": '免费试用',
        onClick: _cache[1] || (_cache[1] = $event => jumpPage('/bookDemoPage.html')),
        isArrow: true
      })])) : _createCommentVNode("", true)]);
    };
  }
};